import axiosInstance from '../RestClient';

const BASE_URI = '/credit-concepts';

class CreditConceptService {
	async list(params = {}) {
		const response = await axiosInstance.get(`${BASE_URI}/`, { params });
		return response;
	}

	async update(concepts) {
		const response = await axiosInstance.put(`${BASE_URI}/`, { concepts });
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async updateOne(id, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${id}`, payload);
		return response;
	}
}

export default new CreditConceptService();

